import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { AgActionIconButtonComponent } from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-file-label',
  standalone: true,
  imports: [AgActionIconButtonComponent, NgbTooltip],
  templateUrl: 'file-label.component.html',
  styleUrl: 'file-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileLabelComponent {
  showControlsOnlyOnHover = input<boolean>(true);
  disabled = input<boolean>(false);
  hideDeleteBtn = input<boolean>(false);
  hideDownloadBtn = input<boolean>(false);
  fileName = input<string | null>(null);

  @Output() downloadFile = new EventEmitter<void>();
  @Output() deleteFile = new EventEmitter<void>();

  onDownloadFile(): void {
    if (this.hideDownloadBtn()) return;
    this.downloadFile.emit();
  }

  onDeleteFile(): void {
    this.deleteFile.emit();
  }
}
